import API_CONFIG from '../config/api';

/**
 * API Service for making fetch requests with the configured base URL
 */
const ApiService = {
  /**
   * Make a fetch request with the proper base URL
   * @param {string} endpoint - API endpoint (should start with /)
   * @param {Object} options - Fetch options
   * @returns {Promise} - Fetch promise
   */
  fetchApi: async (endpoint, options = {}) => {
    const url = `${API_CONFIG.baseURL}${endpoint}`;
    console.log(`Making API request to: ${url}`);
    
    const response = await fetch(url, options);
    return response;
  },
  
  /**
   * Make a GET request
   * @param {string} endpoint - API endpoint
   * @param {Object} headers - Additional headers
   * @returns {Promise} - Response promise
   */
  get: async (endpoint, headers = {}) => {
    const options = {
      method: 'GET',
      headers: {
        ...headers
      }
    };
    
    return ApiService.fetchApi(endpoint, options);
  },
  
  /**
   * Make a POST request
   * @param {string} endpoint - API endpoint
   * @param {Object} data - Request payload
   * @param {Object} headers - Additional headers
   * @returns {Promise} - Response promise
   */
  post: async (endpoint, data = {}, headers = {}) => {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      body: JSON.stringify(data)
    };
    
    return ApiService.fetchApi(endpoint, options);
  },
  
  /**
   * Make a PUT request
   * @param {string} endpoint - API endpoint
   * @param {Object} data - Request payload
   * @param {Object} headers - Additional headers
   * @returns {Promise} - Response promise
   */
  put: async (endpoint, data = {}, headers = {}) => {
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      body: JSON.stringify(data)
    };
    
    return ApiService.fetchApi(endpoint, options);
  },
  
  /**
   * Make a DELETE request
   * @param {string} endpoint - API endpoint
   * @param {Object} headers - Additional headers
   * @returns {Promise} - Response promise
   */
  delete: async (endpoint, headers = {}) => {
    const options = {
      method: 'DELETE',
      headers: {
        ...headers
      }
    };
    
    return ApiService.fetchApi(endpoint, options);
  }
};

export default ApiService;
